import {
  BecomeMemberApiResponse,
  MembershipFormData,
  RegistrationFormPayload,
  FormSubmissionResponse,
} from './types';

const API_BASE_URL = 'https://vlsiapi.bssoftcrm.com';

export const fetchMembershipContent =
  async (): Promise<BecomeMemberApiResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/BecomeMember`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: BecomeMemberApiResponse = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  };

export const submitMembershipForm = async (
  formData: MembershipFormData
): Promise<FormSubmissionResponse> => {
  try {
    const payload: RegistrationFormPayload = {
      name: formData.fullName,
      emailAddress: formData.email,
      contactNumber: formData.phone,
      companyName: formData.companyName,
      linkedln: formData.linkedinProfile,
      statusTypeActive: 1,
    };

    const submitUrl = `${API_BASE_URL}/api/v1.0/RegistrationForm`;

    const response = await fetch(submitUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    // Get the response data regardless of HTTP status
    const data: FormSubmissionResponse = await response.json();

    // Check if the API call was successful but has validation errors
    if (data.succeeded === false || (data.data && data.data.status === 400)) {
      // Handle specific validation errors
      const errorMessage =
        data.data?.message || data.message || 'Registration failed';
      throw new Error(errorMessage);
    }

    // Check for HTTP errors
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return data;
  } catch (error) {
    // Re-throw with better error messages
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('An unexpected error occurred during registration');
  }
};
